import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_ZONE_ID_LOADING = 'GET_ZONE_ID_LOADING';
export const GET_ZONE_ID_SUCCESS = 'GET_ZONE_ID_SUCCESS';
export const GET_ZONE_ID_REJECT = 'GET_ZONE_ID_REJECT';

//* ACTIONS ------------------------------------------------
export const getZoneIdLoading = () => ({ type: GET_ZONE_ID_LOADING });
export const getZoneIdSuccess = (payload) => ({ type: GET_ZONE_ID_SUCCESS, payload });
export const getZoneIdReject = (payload) => ({ type: GET_ZONE_ID_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getZoneIdRequest = async ({ params = {}, id }, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/api/Zones/${id}`, options);
};